import IValidarPinRequestDTO from '../entities/IValidarPinRequestDTO'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IValidarPinTmovPay {
  execute(data: IValidarPinRequestDTO): Promise<void>
}

export default class ValidarPinTmovPayImpl implements IValidarPinTmovPay {
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}

  public async execute(data: IValidarPinRequestDTO): Promise<void> {
    await this.pagamentoRepository.validarPin(data)
  }
}
